<div class="search-box" (resized)="onResized($event)" [class.show-clear]="showClear">
  <i class="fas fa-search"></i>
  <ng-container *ngIf="!selectedValue; else readOnlyField" >
    <input
      [placeholder]="placeholderText"
      placement="top" [disabled]="disabled"
      [tooltip]="tooltipText"
      (keyup)="onTextChange($event)"
      type="text">
  </ng-container>
  <div *ngIf="showClear" class="close-div" tooltip="Limpar" (click)="clear()">
    <i class="fas fa-times"></i>
  </div>
</div>

<ng-template #readOnlyField>
  <input [value]="selectedValue"
    placement="top" readonly
    type="text">
</ng-template>
